import { Icon, Text } from '@components/atoms';
import { Price } from '@components/molecules';
import { SummaryItem, type SummaryItemProps } from './summary-item';

interface ExtendedSummaryProps {
	amount?: number;
	currency?: string;
	label?: string;
	icon: React.ReactElement;
	negative?: boolean;
	summaryList?: SummaryItemProps[];
	withoutTrailingZeros?: boolean;
}

export const ExtendedSummary = ({
	amount,
	currency,
	label,
	icon,
	summaryList,
	negative,
	withoutTrailingZeros,
}: ExtendedSummaryProps) => {
	return (
		<div className="grid grid-cols-[auto_1fr] grid-rows-[auto_1fr] items-center gap-1" data-testid={`${label}-summary`}>
			<Icon size="md" color="element">
				{icon}
			</Icon>
			<div className="flex justify-between">
				<div className="flex items-center gap-1">
					<Text size="xs" weight="medium">
						{label}
					</Text>
				</div>
				<Price
					data-testid={`${label}-summary-amount`}
					size="sm"
					currency={currency}
					price={amount}
					withoutTrailingZeros={withoutTrailingZeros}
				/>
			</div>
			<div className="col-start-2 flex flex-col gap-1">
				{summaryList?.map(item => <SummaryItem key={item.id} {...item} currency={currency} negative={negative} />)}
			</div>
		</div>
	);
};
